import type { SourceUsageDomainType } from "@/components/SourceTable/types";

/** Domains mapped to type. Others resolve to "other". */
export const DOMAIN_TO_TYPE: Record<Exclude<SourceUsageDomainType, "other">, string[]> = {
  news: [
    "techcrunch.com",
    "bbc.com",
    "reuters.com",
    "theguardian.com",
    "techradar.com",
    "theverge.com",
    "wired.com",
    "cnn.com",
    "nytimes.com",
  ],
  social: [
    "reddit.com",
    "twitter.com",
    "x.com",
    "facebook.com",
    "linkedin.com",
    "instagram.com",
    "tiktok.com",
    "youtube.com",
  ],
  forum: ["stackoverflow.com", "quora.com", "medium.com"],
};
